<ng-container>
  <div class="formControl mt">
    <div class="row d-flex align-items-center">
      <div class="col col-md-6">
        <question-description
          titleDir="left"
          subTitleDir="left"
          title="Travaillez-vous dans le secteur de la finance ?"
          [titleStyle]="{ fontSize: '16px' }"
        >
        </question-description>
      </div>
      <div class="col col-md-6 clear-m">
        <pr-input-radio
          formControlName="workInFinance"
          direction="column"
          [isDefault]="false"
          [toggle]="true"
          [options]="options"
        >
        </pr-input-radio>
      </div>
    </div>
    <div class="row d-flex align-items-center">
      <div class="col col-md-6">
        <question-description
          titleDir="left"
          subTitleDir="left"
          title="Avez-vous un crédit ?"
          [titleStyle]="{ fontSize: '16px' }"
        >
        </question-description>
      </div>
      <div class="col col-md-6 clear-m">
        <pr-input-radio
          formControlName="credit"
          direction="column"
          [isDefault]="false"
          [toggle]="true"
          [options]="options"
        >
        </pr-input-radio>
      </div>
    </div>

    <div class="row d-flex align-items-center">
      <div class="col col-md-6">
        <question-description
          titleDir="left"
          subTitleDir="left"
          title="Lisez-vous parfois la presse économique ou patrimoniale ?"
          [titleStyle]="{ fontSize: '16px' }"
        >
        </question-description>
      </div>
      <div class="col col-md-6 clear-m">
        <pr-input-radio
          formControlName="readSpecializedPress"
          direction="column"
          [isDefault]="false"
          [toggle]="true"
          [options]="options"
        >
        </pr-input-radio>
      </div>
    </div>
  </div>
</ng-container>
